import { CandlestickData } from "lightweight-charts"

export class SpecialChart {
    candles: CandlestickData[]

    constructor(candles: CandlestickData[]) {
        this.candles = candles
    }

    getCandles(): CandlestickData[] {
        return []
    }
}